import { linear } from './interpolation'

export function from (x, min, max) {
  return (x - min) / (max - min)
}

export function to (x, min, max) {
  return linear(x, min, max)
}

export function fromTo (x, fmin, fmax, tmin, tmax) {
  return to(from(x, fmin, fmax), tmin, tmax)
}

export function clamp (x, min, max) {
  if (x < min) return min
  if (x > max) return max
  return x
}

export function set (object, name, fn, ...values) {
  if (object[name] === undefined) {
    object[name] = fn(...values)
  } else {
    object[name] = fn(object[name], ...values)
  }
  return object[name]
}

export function min (object, name, ...values) {
  return set(object, name, Math.min, ...values)
}

export function max (object, name, ...values) {
  return set(object, name, Math.max, ...values)
}

export function mod (a, b) {
  return (((a % b) + b) % b)
}

export default {
  from,
  to,
  fromTo,
  clamp,
  set,
  min,
  max,
  mod
}
